import bid1 from '../assets/images/explore/bid1.png';
import bid2 from '../assets/images/explore/bid2.png';
import bid3 from '../assets/images/explore/bid3.png';

import p1 from '../assets/images/HomePage/p 01.png';
import p2 from '../assets/images/HomePage/p 02.png';
import p3 from '../assets/images/HomePage/p 03.png';
import p4 from '../assets/images/HomePage/p 04.png';
import p5 from '../assets/images/HomePage/p 05.png';



export interface collectionsDataType {
    id: number,
    collectionName: string,
    collectionLogo: string,
}


export const collectionsData: collectionsDataType[] = [
    {
        id: 1,
        collectionName: 'Collection 1',
        collectionLogo: bid1,
    },
    {
        id: 2,
        collectionName: 'Collection 2',
        collectionLogo: bid2,
    },
    {
        id: 3,
        collectionName: 'Collection 3',
        collectionLogo: bid3,
    },
    {
        id: 4,
        collectionName: 'Collection 4',
        collectionLogo: bid1,
    },
    {
        id: 5,
        collectionName: 'Collection 5',
        collectionLogo: bid2,
    },
]







export interface followersPeoplesDataType {
    id: number,
    name: string,
    photo: string,
    isActive: boolean,
}


export const followersPeoplesData: followersPeoplesDataType[] = [
    {
        id: 1,
        name: 'George',
        photo: p1,
        isActive: true,
    },
    {
        id: 2,
        name: 'Unfold',
        photo: p2,
        isActive: false,
    },
    {
        id: 3,
        name: 'Netguru',
        photo: p3,
        isActive: true,
    },
    {
        id: 4,
        name: 'Ola',
        photo: p4,
        isActive: false,
    },
    {
        id: 5,
        name: 'Netguru',
        photo: p5,
        isActive: false,
    },
]








export interface allFollowersPeoplesDataType {
    id: number,
    name: string,
    photo: string,
    ifVerified: boolean,
    followersNum: number,
}


export const allFollowersPeoplesData: allFollowersPeoplesDataType[] = [
    {
        id: 1,
        name: "MetaRooks",
        photo: p1,
        followersNum: 602,
        ifVerified: false,
    },

    {
        id: 2,
        name: "Fantastic world",
        photo: p2,
        followersNum: 24,
        ifVerified: false,
    },

    {
        id: 3,
        name: "Tour_De_Terra",
        photo: p3,
        followersNum: 92,
        ifVerified: false,
    },

    {
        id: 4,
        name: "RARIBLE SERVICE",
        photo: p4,
        followersNum: 210,
        ifVerified: false,
    },

    {
        id: 5,
        name: "0xc0a12...2acb",
        photo: p5,
        followersNum: 1,
        ifVerified: false,
    },

    {
        id: 6,
        name: "Life me black and with",
        photo: p1,
        followersNum: 30,
        ifVerified: false,
    },

    {
        id: 7,
        name: "ANGELMODE",
        photo: p2,
        followersNum: 794,
        ifVerified: false,
    },

    {
        id: 8,
        name: "niloofar",
        photo: p3,
        followersNum: 67,
        ifVerified: false,
    },

    {
        id: 9,
        name: "Humanitarian00Smile00Association",
        photo: p4,
        followersNum: 114,
        ifVerified: false,
    },

    {
        id: 10,
        name: "OCENE",
        photo: p5,
        followersNum: 24000,
        ifVerified: false,
    },

    {
        id: 11,
        name: "BLOOD BLACK",
        photo: p1,
        followersNum: 2100,
        ifVerified: false,
    },

    {
        id: 12,
        name: "Pixel T-Shirt Kingdom",
        photo: p2,
        followersNum: 412,
        ifVerified: false,
    },

    {
        id: 13,
        name: "Tipoc",
        photo: p3,
        followersNum: 333,
        ifVerified: false,
    },

    {
        id: 14,
        name: "ITCHY & SCRATCHY",
        photo: p4,
        followersNum: 492,
        ifVerified: false,
    },

    {
        id: 15,
        name: "Tony Inchin",
        photo: p5,
        followersNum: 454,
        ifVerified: false,
    },

    {
        id: 16,
        name: "MARX Avenue",
        photo: p1,
        followersNum: 590,
        ifVerified: false,
    },

    {
        id: 17,
        name: "Schizophrenic from Nowhere",
        photo: p2,
        followersNum: 313,
        ifVerified: false,
    },

    {
        id: 18,
        name: "Rose12",
        photo: p3,
        followersNum: 585,
        ifVerified: false,
    },

    {
        id: 19,
        name: "FOC_NFTs",
        photo: p4,
        followersNum: 253,
        ifVerified: false,
    },

    {
        id: 20,
        name: "uirusu0",
        photo: p5,
        followersNum: 281,
        ifVerified: false,
    },

    {
        id: 21,
        name: "NFT_charity_institution",
        photo: p1,
        followersNum: 482,
        ifVerified: false,
    },

    {
        id: 22,
        name: "voxel town",
        photo: p2,
        followersNum: 423,
        ifVerified: false,
    },

    {
        id: 23,
        name: "Ca_Av_CriptoNFT",
        photo: p3,
        followersNum: 324,
        ifVerified: false,
    },

    {
        id: 24,
        name: "kambamicollection.eth",
        photo: p4,
        followersNum: 1000,
        ifVerified: false,
    },

    {
        id: 25,
        name: "Delaram Karimi",
        photo: p5,
        followersNum: 257,
        ifVerified: false,
    },

    {
        id: 26,
        name: "Kizorico",
        photo: p1,
        followersNum: 651,
        ifVerified: false,
    },

]





